// app/javascript/controllers/file_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "title"]
  
  static values = {
    url: String,
    title: { type: String, default: "Prévisualisation" },
    type: String
  }
  
  connect() {
  }
  
  preview(event) {
    console.log("Preview action triggered")
    
    if (!this.hasModalTarget || !this.hasContentTarget) {
      // console.error("Missing modal or content targets")
      return
    }
    
    const url = event.currentTarget.getAttribute('data-file-preview-url-value')
    const title = event.currentTarget.getAttribute('data-file-preview-title-value') || "Prévisualisation"
    const type = event.currentTarget.getAttribute('data-file-preview-type-value')
    // console.log("Preview data:", { url, title, type })
    
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }
    
    this.contentTarget.innerHTML = ""
    
    if (type === "image") {
      const img = document.createElement("img")
      img.src = url
      img.className = "max-w-full max-h-[70vh]"
      this.contentTarget.appendChild(img)
    } else if (type === "pdf") {
      const iframe = document.createElement("iframe")
      iframe.src = url
      iframe.className = "w-full h-[70vh]"
      this.contentTarget.appendChild(iframe)
    } else {
      this.contentTarget.innerHTML = "<p class='text-center py-8'>Ce type de fichier ne peut pas être prévisualisé.</p>"
    }
    
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
  }
  
  close() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden")
      this.modalTarget.classList.remove("flex")
    }
  }
  
  clickOutside(event) {
    if (this.hasModalTarget && event.target === this.modalTarget) {
      this.close()
    }
  }
}